<template>
  <div 
    :id="`itemexpander-${tourHubItem._id}`"
    :ref="`itemexpander-${tourHubItem._id}`"
    class="item-header item-main"
    :class="{ 'touring-hub-item-active': dropdown }"
    @click="toggleExpand"
  >
    <div class="item-title item-end">
      <span>
        <i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>{{ countryContent.iconName }}</span></i>
      </span>
      <span class="text-uppercase">{{ countryContent.tourStyle }}</span>
    </div>
    
    <div class="item-main-desktop">
      <h6>
        to {{ countryContent.title }}
      </h6>
      <p>{{ durationWithTouringHubServices }}</p>
    </div>    

    <div class="toggle item-end">
      <span v-if="!dropdown">+</span>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    tourHubItem: {
      type: Object
    },
    countryContent: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      dropdown: true
    }
  },
  computed: {
    durationWithTouringHubServices() {
      // some touring hub itineraries will contain a static card which says "Other arrangements booked with Trailfinders. 
      // E.g. an itinerary to costa rica for the first 4 days, then the clients have a G adventures tour for 7 days, and then another 4 days private tour.
      // We want to show the private tour duration as 8 days, rather than 15 days, as only 8 days are private tour / touring hub
      let totalDaysContainingThServices = 0
      const { itinerary } = this.tourHubItem.bookingItinerary
      for (const _day of itinerary) {
        const { services, moduleServices } = _day
        const servicesContainThService = services.some(serv => !serv.hasOtherTfArrangements)
        const moduleServicesContainThService = moduleServices.some(serv => !serv.hasOtherTfArrangements)
        if (servicesContainThService || moduleServicesContainThService) {
          totalDaysContainingThServices++
        }
      }
      return `for ${totalDaysContainingThServices} days`
    }
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
      this.$emit("clicked", this.dropdown);
    },
    expandAll() {
      this.dropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
    },
  }
};

</script>

<style lang="scss">
@import "../styles.scss";
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-end {
  width: 300px;
}
.toggle {
  display: flex;
  justify-content: flex-end;
}
</style>
